module.exports = __webpack_public_path__ + "img/logo_fb.5393d99d.jpg";